import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TypesalleService {
    baseUrl: string = environment.apiUrl;
    constructor(private httpClient: HttpClient) {
     }

    get_typessalles() {
        return this.httpClient.get(this.baseUrl + '/typesSalles');
    }
}
